<template>
  <b-container fluid>

    <b-row v-if="taskReportInfos.length===0">
      <b-col cols="6">

        <b-card bg-variant="default" header="" class="text-left mt-4">
            <b-card-text>
              {{ 'EMPTY_REPORT_PAGE' | i18n  }}
            </b-card-text>

        </b-card>

      </b-col>
    </b-row>

    <b-row>
      <b-col cols="6">

        <template v-for="(info,idx) in taskReportInfos">
          <b-card :bg-variant="cardVariant(info.state)" :header="cardTitle(info)" class="text-left mt-4" :key="idx">

            <template v-if="info.state==='OPEN' || info.state==='PROCESSING'">
              <div class="text-center">

                <b-spinner v-if="info.state==='OPEN'" small type="grow"></b-spinner>
                <b-spinner v-else variant="primary"></b-spinner>
                <div>{{'TASK_JOB_POSITION' | i18n}}: {{info.placement}}</div>
              </div>
            </template>
            <template v-else-if="info.state==='CLOSED'">
              <b-card-text>
                {{'DOWNLOAD_REPORT' | i18n}}: <a v-if="info.link" :href="info.link">link</a>
              </b-card-text>

            </template>

          </b-card>
        </template>

      </b-col>
    </b-row>

  </b-container>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import ReportsService from "../../services/ReportsService";

  export default {
    name: 'ReportsPage',

    data() {
      return {
        taskReportInfos: [],
        interval: null
      }
    },

    components: {
    },

    computed: {
      ...mapState(['activeSurvey', 'absoluteDrillPath', 'reports']),
      ...mapGetters(['realmName', 'studyName', 'authToken', 'pageByName', 'completePath']),
    },

    beforeDestroy() {
      this.stopReportPolling()
    },

     methods: {
      cardVariant(state) {
        if(state==='OPEN' || state==='PROCESSING') {
          return 'light'
        }
        if(state==='CLOSED') {
          return 'default'
        }

        return 'warning'
      },

       cardTitle(info) {
           return info.reportName + " - " + info.stateTitle
       },

       loadReportsData(/*externId*/) {

         ReportsService.requestReportInfos(this.authToken, this.realmName, this.studyName, this.reports).then((response) => {
           //  console.log("requestReportInfos")
           // console.log(response.data)
           this.taskReportInfos = response.data;
         })

      },

       startReportPolling() {
         this.interval = setInterval(this.pollReportStatus, 2000)
       },

       stopReportPolling() {
         clearInterval(this.interval)
       },

       pollReportStatus() {
          this.loadReportsData()
       }

     },

    watch: {
      $route: {
        handler() {
          this.loadReportsData()
          this.startReportPolling();
        },
        immediate: true
      },

    }

  }
</script>